module.exports = __webpack_public_path__ + "img/EXV_Weinflaschen_Icons_Weissweine.c69310dc.svg";